import React from "react";

const TEXT = {
    DRAFT: ["info", "Draft — only you can see this. Submit it for review when it's ready; our team usually reviews within a working day."],
    IN_REVIEW: ["info", "In review. You can still make changes; we'll email you when it's decided."],
    CHANGES_REQUESTED: ["warn", "Our team asked for changes. Update it and submit again."],
    REJECTED: ["error", "This wasn't approved and won't be published."],
    APPROVED: ["ok", "Approved. Changes you save now are reviewed before they go live; price and sold-out update immediately."],
};

/** What the review state means for the broker, and the reviewer's note when there is one. */
const ReviewNotice = ({status, note, pendingChanges, what = "listing"}) => {
    const [tone, text] = TEXT[status] || ["info", ""];
    return (
        <div className={`brk-notice brk-notice--${pendingChanges ? "info" : tone}`} role="status">
            <p>{pendingChanges ? `Your latest edits to this ${what} are waiting for review; the live version stays as it is until then.` : text}</p>
            {note && <p className="brk-notice__note"><strong>Reviewer's note:</strong> {note}</p>}
        </div>
    );
};

export default ReviewNotice;
